import { Observable } from 'rxjs';
import { AuthModel, AuthResponseModel } from '../model/AuthModel';

export abstract class AuthRepository {
    abstract login(auth: AuthModel): Observable<AuthResponseModel>;
}
